import React from "react";

export function HorizontalLineWidget(props) {
  const { ui } = props;
  const widgetId = ui.id;

  const lineStyle = {
    position: "relative",
    top: "50%",
    transform: "translateY(-50%)"
  }

  return (
    <div id={widgetId} style={lineStyle}>
      <hr />
    </div>
  );
}